module.exports = __webpack_public_path__ + "img/Monte_Kope_59.89abe64e.jpg";